import { render, staticRenderFns } from "./UserP2P.vue?vue&type=template&id=0b9a5cfa&"
import script from "./UserP2P.vue?vue&type=script&lang=js&"
export * from "./UserP2P.vue?vue&type=script&lang=js&"
import style0 from "./UserP2P.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports